import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class AdPlaying extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        methods: PropTypes.object.isRequired,
    };

    handleVoiceBtnMouseDown = (e) => {
        if (e.button === 0) {
            this.clickData = {
                startTime: Date.now(),
            };
        }
    };

    handleVoiceBtnMouseUp = (e) => {
        if (e.button === 0 && this.clickData) {
            this.clickData.endTime = Date.now();
        }
    };

    handleVoiceBtnClick = (e) => {
        const { content, methods } = this.props;
        const { canPlaySounds, clickPlaySounds } = content;
        const { handleChangeClickPlaySounds, handleChangePlaySounds, handlePlaySoundsCount } = methods;
        const currentPlaySounds = canPlaySounds && clickPlaySounds;

        if (currentPlaySounds) {
            handleChangeClickPlaySounds(false);
        } else {
            handleChangePlaySounds({ canPlaySounds: true, clickPlaySounds: true });
        }

        if (this.clickData && this.clickData.startTime) {
            if (!this.clickData.endTime) {
                this.clickData.endTime = Date.now();
            }

            const { startTime, endTime } = this.clickData;
            const pointerClientX = e.clientX;
            const pointerClientY = e.clientY;

            handlePlaySoundsCount({ startTime, endTime, pointerClientX, pointerClientY, currentPlaySounds });
        }
    };

    render() {
        const { content } = this.props;
        const { countdown, canPlaySounds, clickPlaySounds } = content;

        return (
            <div className={styles.wrap}>
                <div className={styles.countdown}>{countdown}s</div>
                <div
                    className={`${styles.voiceBtn} ${!(canPlaySounds && clickPlaySounds) ? styles.voiceBtnMuted : ''}`}
                    onClick={this.handleVoiceBtnClick}
                    onMouseDown={this.handleVoiceBtnMouseDown}
                    onMouseUp={this.handleVoiceBtnMouseUp}
                />
            </div>
        );
    }
}

export default AdPlaying;
